import { render, staticRenderFns } from "./ShowImg.vue?vue&type=template&id=428d50ee&scoped=true&"
import script from "./ShowImg.vue?vue&type=script&lang=js&"
export * from "./ShowImg.vue?vue&type=script&lang=js&"
import style0 from "./ShowImg.vue?vue&type=style&index=0&id=428d50ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d50ee",
  null
  
)

export default component.exports